import { cn } from '@/utils/tailwind';
import { Loader2 } from 'lucide-react';
import { RefObject } from 'react';

type InfiniteScrollSentinelProps = {
  listEndSentinelRef: RefObject<HTMLDivElement>;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  className?: string;
};

export const InfiniteScrollSentinel = ({
  listEndSentinelRef,
  hasNextPage,
  isFetchingNextPage,
  className,
}: InfiniteScrollSentinelProps) => {
  if (!hasNextPage && !isFetchingNextPage) {
    return null;
  }

  return (
    <div
      ref={listEndSentinelRef}
      aria-hidden={!isFetchingNextPage}
      className={cn(
        'flex min-h-[56px] w-full items-center justify-center text-gr-500 Caption1M12',
        className,
      )}
    >
      {isFetchingNextPage && (
        <div className="flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          <span>주문을 더 불러오는 중</span>
        </div>
      )}
    </div>
  );
};
